"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var operators_1 = require("rxjs/operators");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_entity_search_client_js_1 = require("@synisys/idm-entity-search-client-js");
var SisDynamicEntitySelectComponent = /** @class */ (function () {
    function SisDynamicEntitySelectComponent(kbService, deService) {
        this.kbService = kbService;
        this.deService = deService;
        this.isReadonly = false;
        this.entityChange = new core_1.EventEmitter();
        this.entityBuilder = new idm_de_core_frontend_1.EntityBuilder();
    }
    Object.defineProperty(SisDynamicEntitySelectComponent.prototype, "nameFields", {
        get: function () {
            return this._nameFields;
        },
        set: function (value) {
            this._nameFields = value || [];
        },
        enumerable: true,
        configurable: true
    });
    SisDynamicEntitySelectComponent.prototype.submitEntity = function (entity) {
        var _this = this;
        if (this.formCategory && this.fieldName) {
            this.kbService
                .getMainEntityMetaFields(this.formCategory, this.fieldName)
                .pipe(operators_1.first())
                .subscribe(function (metaFields) {
                _this.entityChange.emit(_this.entityBuilder.createEntity(idm_de_service_client_js_1.MainEntity, metaFields, entity));
            }, function (e) { return console.log(e); });
        }
    };
    SisDynamicEntitySelectComponent.prototype.getEntityName = function () {
        return this.deService.getEntityName(this.compoundCategory, this.value, ' ');
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisDynamicEntitySelectComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.Entity)
    ], SisDynamicEntitySelectComponent.prototype, "value", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisDynamicEntitySelectComponent.prototype, "formCategory", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisDynamicEntitySelectComponent.prototype, "fieldName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisDynamicEntitySelectComponent.prototype, "compoundCategory", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisDynamicEntitySelectComponent.prototype, "isReadonly", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisDynamicEntitySelectComponent.prototype, "entityChange", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], SisDynamicEntitySelectComponent.prototype, "nameFields", null);
    SisDynamicEntitySelectComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-dynamic-entity-select',
            template: require('./sis-dynamic-entity-select.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            name: 'Single Select Entity Search',
            settings: {
                main: idm_entity_search_client_js_1.SisSingleSelectEntitySearchSettingsComponent,
            },
            template: "\n\t\t<sis-dynamic-entity-select\n\t\t\t[id]=\"'%{id}'\"\n\t\t\t[value]=\"%{field}\"\n\t\t\t(entityChange)=\"actions.simpleChange(contextEntity, '%{field-name}', $event)\"\n\t\t\t[compoundCategory]=\"'%{field-category}'\"\n\t\t\t[fieldName]=\"'%{field-name}'\"\n\t\t\t[formCategory]=\"category\"\n\t\t\t[nameFields]=\"%{filterFields}\"\n\t\t\t[isReadonly]=\"%{isReadonly}\">\n\t\t</sis-dynamic-entity-select>",
            defaultActions: {
                filterFields: 'nameMetaFields-async',
            },
            isFieldBound: true,
        }),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService, idm_de_service_client_js_1.DeService])
    ], SisDynamicEntitySelectComponent);
    return SisDynamicEntitySelectComponent;
}());
exports.SisDynamicEntitySelectComponent = SisDynamicEntitySelectComponent;
//# sourceMappingURL=sis-dynamic-entity-select.component.js.map